import React from 'react';
import Navigation from './components/Navigation';
import AnimationHero from './components/AnimationHero';
import ValueProposition from './components/ValueProposition';
import BenefitsSection from './components/BenefitsSection';
import PainPointsSection from './components/PainPointsSection';
import FeatureCards from './components/FeatureCards';
import ServicesShowcase from './components/ServicesShowcase';
import EdgeSection from './components/EdgeSection';
import InteractiveDemo from './components/InteractiveDemo';
import CTASection from './components/CTASection';
import Contact from './components/Contact';
import Footer from './components/Footer';

function App() {
    return (
        <div className="App">
            <Navigation />
            <AnimationHero />
            <ValueProposition />
            <FeatureCards />
            <ServicesShowcase />
            <BenefitsSection />
            <PainPointsSection />
            <EdgeSection />
            <InteractiveDemo />
            <CTASection />
            <Contact />
            <Footer />
        </div>
    );
}

export default App;

